import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import Layout from './Layout';
import ReactGA from 'react-ga';

// Routers
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

// Components
import Homepage from './Pages/Home/index';
import About from './Pages/About/index';
import SanityPages from './Pages/SanityPages/index';
import NotFound from './Pages/NotFound/index';

// Styles
import './styles.scss';
ReactGA.initialize('UA-183118447-1', {
  debug: true,
  gaOptions: {
    siteSpeedSampleRate: 100
  }
});
ReactGA.pageview(window.location.pathname + window.location.search);

// const pageViewsTracking = (props) => {
// 	const pathname = props.match.path;

// 	let pageview;
// 	if (pathname === '*') pageview = 'notfound';
// 	else pageview = pathname

// 	ReactGA.pageview(pageview);

// }

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route index path="/" exact element={<Homepage />} />

      <Route element={<Layout />}>
        <Route path="/:slug" element={<SanityPages />} />
        <Route path="/about" element={<About />} />
        <Route path="*/*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
